module.exports = __webpack_public_path__ + "img/8851d1c.jpg";